import React from 'react';
import CloneSalePriceButtonProperties from "./CloneSalePriceButtonProperties";
import CloneSalePriceStore from "./CloneSalePriceStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import {useCommonContext} from "../../../contexts/CommonContext";
import useConfirmation from "../../../hooks/ConfirmationDialog";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import Button from "../../../ui_components/Button/Button";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const CloneSalePriceButton: React.FC<CloneSalePriceButtonProperties> = ({
                                                                        onClick = () => {
                                                                        },
                                                                        onSave = () => {
                                                                        },
                                                                        showIcon = true,
                                                                        showText = true,
                                                                        disabled,
                                                                        className = '',
                                                                        salePrice,
                                                                        rounded = false,
                                                                        size = ButtonSize.DEFAULT,
                                                                        type = ButtonType.DEFAULT
                                                                    }) => {

    const confirm = useConfirmation();
    const commonContext = useCommonContext();
    const store = new CloneSalePriceStore(commonContext, salePrice);

    const handleOnclick = async () => {
        onClick();
        const ok = await confirm(salePrice.name, "¿Está seguro que desea duplicar la lista de precios de venta?");
        if (ok) {
            await store.clone();
            onSave();
        }
    }

    const text = 'Duplicar precios de venta';
    const Icon = ContentCopyIcon;

    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                size={size}
                type={type}
                icon={showIcon ? <Icon/> : <></>}
            />
        }
        return <Button
            onClick={handleOnclick}
            className={className}
            disabled={disabled}
            tooltip={!showText ? text : ""}
            text={showText ? text : ""}
            size={size}
            type={type}
            startIcon={showIcon ? <Icon/> : <></>}
        />
    }

    return <Observer>
        {() => (
            <Btn/>
        )}
    </Observer>
}

export default CloneSalePriceButton;
